import controller from './admin-kia-doctype.controller';
import template from './admin-kia-doctype.html';
import './admin-kia-doctype.scss';

export default {
	controller,
	controllerAs: '$ctrl',
	path:         '/admin/kia-doctype',
	template,
	title:        'menu.admin-kia-doctype',
};
